// Hardik and arturo added this code

$(document).ready(function() {

  const add_cookies = false; //if you want to activate the cookies and only show the video the first time the user lands on the site, set to true
  // if you want to show the video everytime the user goes home, set add_cookies to false

  const move_to_page_automatically = true; //if you want to automatically go to homepage once intro animation is done, set to true
  // if you do not want to go to homepage, automatically, set to false

  const time_on_hold = 6; // the number of seconds you would like to wait till you automatically open the homepage and hide the intro video

  if(add_cookies){
    if ($.cookie('video_closed')) {
       $('.video-intro-wrapper').hide();
      $('.video-overlay-section').hide();
    } else {
      $('.template-index .video-overlay-section').addClass('Video-overlay');
      $('.video-intro-wrapper').addClass('fadeIn');
      $('.video-intro-wrapper').attr('aria-hidden', true);
    }

    $(document).on('click', '.video-intro-wrapper', function () {
      $('.video-intro-wrapper').addClass('video-clicked').addClass('fadeOut').removeClass('fadeIn');
      $('.template-index .video-overlay-section').removeClass('Video-overlay');
  
      var date = new Date();
      date.setTime(date.getTime() + (10* 60 * 60 * 1000)); //add days to current date-time 1s = 1000ms
  
      $('.video-intro-wrapper').attr('aria-hidden', true);
      console.log('cookie', date);
      $.cookie('video_closed', 1, { expires: date });
    });
    
  } else {
    $('.template-index .video-overlay-section').addClass('Video-overlay');
    $('.video-intro-wrapper').addClass('fadeIn');
    $('.video-intro-wrapper').attr('aria-hidden', true);
  
    $(document).on('click', '.video-intro-wrapper', function () {
      $('.video-intro-wrapper').addClass('video-clicked').addClass('fadeOut').removeClass('fadeIn');
      $('.template-index .video-overlay-section').removeClass('Video-overlay');
  
      $('.video-intro-wrapper').attr('aria-hidden', true);
    });
  }

  if(move_to_page_automatically) {
   // once the video is done playing, open homescreen
    setTimeout(function(){
        $('.video-intro-wrapper').addClass('video-clicked').addClass('fadeOut').removeClass('fadeIn');
        $('.template-index .video-overlay-section').removeClass('Video-overlay');
    }, (time_on_hold*1000)); 
  }
  
});